<template>
  <div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        time: '',
        statusGeral: '',
        config: {},
        files: [ ],
        router: '',
        envio: null
      }
    },
    mounted: function () {
      var self = this

      // CHAMA A FUNÇÃO PARA INICIAR
      setTimeout(function () {
        self.conectorServicoIniciar()
      }, 2000)
    },
    methods: {
      conectorServicoIniciar: function () {
        var self = this

        // ALTERA O ICONE
        self.$store.state.ECT_COMUNICA_RENDERER('ALTERAR_TRAY', { tipo: 'iniciando' })

        // SETA O STATUS CARREGANDO DA PAGINA
        self.conectorServicoStatusGeral('carregando')

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES DA INTEGRAÇÃO
        self.$store.state.GET_VALUE_LOCAL_STORAGE('CONECTOR', function (config) {
          // SETA O VALOR RECEBIDO
          self.config = config

          // VERIFICA SE TEM AS CONFIGURAÇÕES DE INTEGRAÇÃO
          if (Object.keys(self.config).length >= 1 && Object.keys(self.config).length >= 1 && self.config.hasOwnProperty('integracao') && self.config.hasOwnProperty('usuario') && self.config.usuario.filter(item => item.padrao === true).length >= 1) {
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { f: 'id_int', o: '=', v: self.config.integracao.id } }

            self.$store.state.comunicaAPI('/integracao/rota/get/', 'GET', queryGet, function (apiSuccess) {
              // SETA A ROTA DE COMUNICAÇÃO
              self.router = apiSuccess.data[0].uri.substring(process.env.VUE_APP_URL_API.length, apiSuccess.data[0].uri.length)

              // REALIZA A COMUNICAÇÃO COM O ELECTRON PARA MONITORAR A PASTA
              self.$store.state.ECT_COMUNICA_RENDERER('MONITORAR_PASTA', { pasta: './uploads' }, function (args) {
                if (args.hasOwnProperty('message')) {
                  // SETA O STATUS CARREGANDO DA PAGINA
                  self.conectorServicoStatusGeral('')

                  // ALTERA O ICONE
                  self.$store.state.ECT_COMUNICA_RENDERER('ALTERAR_TRAY', { tipo: 'iniciar' })
                } else if (self.files.indexOf(args) === -1) {
                  // REMOVE A PASTA UPLOADS DO CAMINHO DO ARQUIVO
                  if (args.indexOf('uploads') !== -1) {
                    args = args.substring(10, args.length)
                  }

                  // ADICIONA O ARQUIVO NO VETOR
                  self.files.push(args)
                }
              })
            }, self.conectorServicoStatusGeral)
          } else {
            // ALTERA O ICONE
            self.$store.state.ECT_COMUNICA_RENDERER('ALTERAR_TRAY', { tipo: 'sem_configuracao' })
          }
        }, process.env.VUE_APP_CRI_KEY)
      },
      conectorServicoStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },

      conectorServicoEnvioIniciar: function () {
        var self = this

        if (self.envio === null && self.files.length >= 1) {
          // ALTERA O ICONE
          self.$store.state.ECT_COMUNICA_RENDERER('ALTERAR_TRAY', { tipo: 'enviando' })

          // SETA QUE ESTA INICIANDO O PROCESSO
          self.envio = ''

          // FAZ A LEITURA DO ARQUIVO
          self.$store.state.ECT_COMUNICA_RENDERER('LER_ARQUIVO', { pasta: './uploads', file: self.files[0] }, function (args) {
            // REMOVE 2 ESPAÇO E SUBSTITUI POR 1 ESPAÇO
            while (args.indexOf('  ') !== -1) {
              args = args.replace('  ', ' ')
            }

            // REMOVE A / QUE EXISTE DENTRO DO JSON
            while (args.indexOf('/') !== -1) {
              args = args.replace('/', '')
            }

            // PEGA OS DADOS DO ARQUIVO RECEBIDO
            self.envio = JSON.parse(args)

            // CRIA O CABEÇALHO E COMUNICA COM A API
            self.conectorServicoCriarIntegracao(self.conectorServicoEnviarArquivo)
          })
        } else {
          // CHAMA A FUNÇÃO PARA FINALIZAR O ENVIO
          self.conectorServicoEnvioFinalizar()
        }
      },
      conectorServicoCriarIntegracao: function (callback) {
        // VERIFICA SE INICIOU A VARIAVEL INTEGRAÇÃO
        if (!this.envio.hasOwnProperty('integracao')) {
          this.envio.integracao = {}
        }

        // VERIFICA SE TEM CODIGO DA LICENÇA SELECIONADO
        if (!this.envio.integracao.hasOwnProperty('cod_ldu') || [ '', null, undefined ].indexOf(this.envio.integracao.cod_ldu) === -1) {
          this.envio.integracao.cod_ldu = this.config.clu
        }

        // VERIFICA SE EXISTE USUARIO SETADO
        if (!this.envio.integracao.hasOwnProperty('cod_usu') || [ '', null, undefined ].indexOf(this.envio.integracao.cod_usu) === -1) {
          this.envio.integracao.cod_usu = this.config.usuario.filter(item => item.padrao === true)[0].id
        }

        // VERIFICA SE TEM CHAVE DE PARCEIRO SETADA
        if (!this.envio.integracao.hasOwnProperty('cha_par') || [ '', null, undefined ].indexOf(this.envio.integracao.cha_par) === -1) {
          this.envio.integracao.cha_par = this.config.parceiro.chave
        }

        // SETA O VALOR DO CONTEUDO ATUALIZADO
        this.envio.conteudo = JSON.parse(JSON.stringify(this.envio.conteudo))

        // VERIFICA SE TEM CHAVE DE COMUNICAÇÃO
        if (!this.envio.integracao.hasOwnProperty('cha_com') || [ '', null, undefined ].indexOf(this.envio.integracao.cha_com) === -1) {
          // PEGA OS DADOS DO USUARIO
          var usuario = this.config.usuario.filter(item => item.id === this.envio.integracao.cod_usu)[0]

          // MONTA A STRING QUE SERÁ CALCULADO O MD5
          var string = usuario.chave + JSON.stringify(this.envio.conteudo)

          // IMPORTA A BIBLIOTECA CRYPTO
          var CryptoJS = require('crypto-js')

          // CALCULA O MD5 DA STRING
          this.envio.integracao.cha_com = CryptoJS.MD5(string).toString()
        }

        callback()
      },
      conectorServicoEnviarArquivo: function () {
        var self = this

        self.$store.state.comunicaAPI(self.router, 'POST', self.envio, function (apiSuccess) {
          // PEGA O RETORNO DA API
          var retorno = apiSuccess.lot[0]

          // INICIA VARIALVE PARA IMPRESSÃO
          var imprimir = true

          if (self.envio.hasOwnProperty('conteudo') && Object.keys(self.envio).length >= 1) {
            // PEGA QUAL É A CHAVE DO ARQUIVO
            var key = Object.keys(self.envio.conteudo)[0]

            // VERIFICA SE EXISTE A CHAVE PARA IMPRIMIR
            if (self.envio.conteudo[key].hasOwnProperty('produtos') && self.envio.conteudo[key].produtos.hasOwnProperty('rfc_imprimir')) {
              imprimir = self.envio.conteudo[key].produtos.rfc_imprimir
            }
          }

          if (retorno.hasOwnProperty('ref') && retorno.ref.hasOwnProperty('rDanfe')) {
            if (imprimir !== false) {
              self.conectorServicoImprimir(retorno.ref.rDanfe, retorno.ref.rDocModelo + '_' + retorno.ref.rDocNumero + '_' + retorno.ref.rDocSerie + '_' + retorno.ref.rDocChaAcesso + '.pdf', true)
            }

            // DELETA O ARQUIVO QUE FOI ENVIADO
            self.$store.state.ECT_COMUNICA_RENDERER('DELETE_ARQUIVO', { pasta: './uploads', file: self.files[0] })

            // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
            self.conectorServicoReiniciar()
          } else {
            // APRESENTA A MENSAGEM DE ERRO NA TELA
            self.$store.state.msgWarn('API [' + retorno.code + ']' + retorno.message, 'danger')

            // IMPRIME O ERRO
            self.conectorServicoImprimir({ code: retorno.code, message: retorno.message })

            // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
            self.conectorServicoReiniciar()
          }
        }, function () {
          // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
          self.conectorServicoReiniciar()
        }, function (apiValid, apiStatus) {
          // IMPRIME O ERRO
          self.conectorServicoImprimir({ code: apiStatus, message: apiValid.geralWeb })

          // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
          self.conectorServicoReiniciar()
        }, null, null, false)
      },
      conectorServicoReiniciar: function () {
        // REMOVE OS FLAGS E LIBERA O SERVIÇO
        this.files.splice(0, 1)
        this.envio = null

        // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
        this.conectorServicoEnvioIniciar()
      },
      conectorServicoImprimir: function (conteudo = '', file = '', pdfB64 = false) {
        var impressora = ''

        // SETA UMA MENSAGEM DE ERRO PADRÃO, CASO NÃO CONSIGA IDENTIFICAR O ERRO
        if ([ '', null ].indexOf(conteudo) !== -1) {
          conteudo = { code: '500', message: 'Erro ao pegar conteudo para imprimir' }
          file = ''
        }

        if (file === '') {
          file = 'Erro - ' + new Date().getTime() + '.pdf'
        }

        // VERIFICA SE ENCONTRA A IMPRESSORA PARA O USUARIO DA REQUISIÇÃO
        if (this.envio !== null && this.envio.hasOwnProperty('integracao') && this.envio.hasOwnProperty('cod_usu')) {
          impressora = this.config.usuario.filter(item => item.id === this.envio.integracao.cod_usu)[0].impressora
        }

        // PEGA QUAL É A IMPRESSORA SELECIONADA PARA O USUARIO PADRÃO
        if (impressora === '') {          
          impressora = this.config.usuario.filter(item => item.padrao === true)
          impressora = impressora.length >= 1 ? impressora[0].impressora : ''
        }

        // CHAMA A FUNÇÃO DO ELETRON PARA REALIZAR A IMPRESSÃO
        this.$store.state.ECT_COMUNICA_RENDERER('IMPRIMIR', { impressora: impressora, file: file, conteudo: conteudo, pdfB64: pdfB64 })
      },
      conectorServicoEnvioFinalizar: function () {
        // ALTERA O ICONE
        this.$store.state.ECT_COMUNICA_RENDERER('ALTERAR_TRAY', { tipo: 'parado' })

        // LIMPA OS DADOS DO ENVIO
        this.envio = null

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    watch: {
      files: function () {
        if (this.envio === null) {
          this.conectorServicoEnvioIniciar()
        }
      }
    }
  }
</script>